// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HighlightTwoToneSvg from "@fishx/icons-svg/es/asn/HighlightTwoTone";
import FishxIcon from '../components/FishxIcon';

var HighlightTwoTone = function HighlightTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HighlightTwoToneSvg
  }));
};

HighlightTwoTone.displayName = 'HighlightTwoTone';
export default React.forwardRef(HighlightTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HighlightTwoTone.js
// module id = 2932
// module chunks = 0